import type {App} from 'vue';
import type {AppAxiosRequestConfig} from '@/helpers/api';
import {platform} from '@/api/platform';

export default {
    install(app: App, options: AppAxiosRequestConfig) {

        platform.defaults.baseURL = options.baseURL;

        if (options.params) {

            platform.defaults.params = options.params;
        }

        app.provide("$platform", platform);
        app.config.globalProperties.$platform = platform;
    }
}